import React, { useEffect } from 'react';
import { addRestaurantIdToOldMesas } from './addRestaurantIdToOldMesas';

const MigrateMesas: React.FC = () => {
  useEffect(() => {
    addRestaurantIdToOldMesas();
  }, []);

  return <p>Migración ejecutándose... Revisa la consola.</p>;
};

export default MigrateMesas;
